"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesListGrid = CompaniesListGrid;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const uuid = __importStar(require("uuid"));
const truncate_1 = __importDefault(require("lodash/truncate"));
const react_intl_1 = require("react-intl");
const buildings_modern_1 = __importDefault(require("@src/components/elements/Icon/custom/buildings-modern"));
const get_cdn_image_url_1 = require("@shared/get-cdn-image-url");
const styled_components_1 = require("styled-components");
const CompanySubscriptionBlock_1 = require("@src/components/modules/global/CompanySubscriptionBlock/CompanySubscriptionBlock");
const CompaniesListGrid_style_1 = require("./CompaniesListGrid.style");
const MissingContentView_1 = __importDefault(require("../../MissingContentView/MissingContentView"));
const HidePopoverStyles = (0, styled_components_1.createGlobalStyle) `
	.ant-popover.ant-avatar-group-popover.ant-popover-placement-top {
		display: none;
	}
`;
function CompaniesListGrid({ companies, isLoading }) {
    const intl = (0, react_intl_1.useIntl)();
    const isCompanyListNotEmpty = Boolean(companies && companies.length);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HidePopoverStyles, {}), (0, jsx_runtime_1.jsxs)(CompaniesListGrid_style_1.CompaniesListGridWrapper, { children: [isLoading &&
                        new Array(10).fill(null).map(() => ((0, jsx_runtime_1.jsxs)(CompaniesListGrid_style_1.CompanyCard, { className: "p-m", children: [(0, jsx_runtime_1.jsx)(antd_1.Skeleton.Image, {}), (0, jsx_runtime_1.jsx)(antd_1.Skeleton, { active: true, paragraph: { rows: 3 } })] }, uuid.v4()))), !isLoading &&
                        isCompanyListNotEmpty &&
                        (companies === null || companies === void 0 ? void 0 : companies.map(c => {
                            const companyLogoSrc = (0, get_cdn_image_url_1.getCdnImageUrl)({
                                file: `web/company/${c.image}`,
                                transformation: 'w_300,h_300,c_limit',
                            });
                            return ((0, jsx_runtime_1.jsxs)(CompaniesListGrid_style_1.CompanyCard, { children: [(0, jsx_runtime_1.jsxs)(CompaniesListGrid_style_1.ImageBlock, { to: `/firma/${c.company_url}`, alt: c.name, children: [c.image && (0, jsx_runtime_1.jsx)("img", { src: companyLogoSrc, alt: "logo" }), !c.image && (0, jsx_runtime_1.jsx)(buildings_modern_1.default, {})] }), (0, jsx_runtime_1.jsxs)(CompaniesListGrid_style_1.CompanyCardContent, { children: [(0, jsx_runtime_1.jsx)(CompaniesListGrid_style_1.CompanyName, { to: `/firma/${c.company_url}`, alt: c.name, children: (0, truncate_1.default)(c.name, { length: 40 }) }), (0, jsx_runtime_1.jsx)(CompanySubscriptionBlock_1.CompanySubscriptionBlock, { companyId: c.id, subscribers: c.subscribers })] })] }, c.id));
                        })), !isLoading && !isCompanyListNotEmpty && ((0, jsx_runtime_1.jsx)(CompaniesListGrid_style_1.MissingContentViewWrapper, { children: (0, jsx_runtime_1.jsx)(MissingContentView_1.default, { heading: intl.formatMessage({
                                id: 'companies_list.missing_content_heading',
                            }), message: intl.formatMessage({
                                id: 'companies_list.missing_content_message',
                            }) }) }))] })] }));
}
